import { isMobileApp, ttobakAppVersionCheck } from '@/utils/common';

export const backFunc = (emit: (event: 'clickBack', ...args: any[]) => void): void => {
  const router = useRouter();
  
  const backPath = router.options.history.state?.back || null;
  const historyLength = window.history.length;
  
  if(backPath == null || historyLength === 1) {
    if (isMobileApp() && ttobakAppVersionCheck() === 'vsl4') {
      router.replace('/');
    } else {
      emit("clickBack");
    }
  } else {
    emit("clickBack");
  }
};